const en_sales_invoice = {
    "": "sales invoice",
    add: "create sales invoice",
    detail: "sales invoice detail",
    edit: "edit sales invoice",
    history: "invoice history",

    label: {
        payment_type: "invoice type",
        disc_before_ppn: "discount before PPN",
        do_list: "DO list",
        so_list: "SO list",
    },

    error: {
        bank_destination: "Destination bank cannot be empty.",
        create: "Failed to create sales invoice.",
        edit: "Failed to update sales invoice.",
        payment_type: "Invoice type cannot be empty.",
    },

    success: {
        create: "Sales invoice created successfully.",
        edit: "Sales invoice updated successfully.",
    },
}

export default en_sales_invoice;